/**
 * AI Workflows API
 *
 * Backed by `GET /api/ai-core/workflows`. The server returns a trimmed
 * projection of the WorkflowSpec registry — no plan, no promptCard, no
 * inputSchema. Frontend uses the list to resolve `workflowId` →
 * human-readable `displayName` on the WorkflowProgressCard.
 */
import { apiFetch } from './client';

const BASE_URL = '/api/ai-core';

export interface WorkflowSummary {
  id: string;
  displayName: string;
  ownerPluginId: string;
  totalSteps: number;
  requiredPermissions: readonly string[];
}

export const listAiWorkflows = async (): Promise<WorkflowSummary[]> => {
  return apiFetch<WorkflowSummary[]>(`${BASE_URL}/workflows`, {
    credentials: 'include',
  });
};
